import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import { Spinner } from "@/components/UI";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Kanban from "@/pages/Kanban";
import Profile from "@/pages/Profile";
import SprintBoard from "@/pages/SprintBoard";
import SprintList from "@/pages/SprintList";
import SprintDetail from "@/pages/SprintDetail";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import Timeline from "@/pages/Timeline";
import Employees from "@/pages/Employees";
import Performance, { AdminLaporan } from "@/pages/Performance";
import EmployeeDetail from "@/pages/EmployeeDetail";
import Approvals from "@/pages/Approvals";
import AuditTrail from "@/pages/AuditTrail";
import Backlog from "@/pages/Backlog";
import Archive from "@/pages/Archive";

function Protected({ children, adminOnly, employeeOnly }) {
  const { user, isAdmin } = useAuth();
  if (user === undefined) return <div className="min-h-screen bg-slate-950"><Spinner /></div>;
  if (user === null) return <Navigate to="/login" replace />;
  if (adminOnly && !isAdmin) return <Navigate to="/" replace />;
  if (employeeOnly && isAdmin) return <Navigate to="/projects" replace />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/kanban" element={<Protected><Kanban /></Protected>} />
      <Route path="/sprint" element={<Protected adminOnly><SprintBoard /></Protected>} />
      <Route path="/sprints" element={<Protected adminOnly><SprintList /></Protected>} />
      <Route path="/sprints/:id" element={<Protected adminOnly><SprintDetail /></Protected>} />
      <Route path="/projects" element={<Protected><Projects /></Protected>} />
      <Route path="/projects/:id" element={<Protected><ProjectDetail /></Protected>} />
      <Route path="/backlog" element={<Protected><Backlog /></Protected>} />
      <Route path="/archive" element={<Protected><Archive /></Protected>} />
      <Route path="/timeline" element={<Protected><Timeline /></Protected>} />
      <Route path="/employees" element={<Protected adminOnly><Employees /></Protected>} />
      <Route path="/performance" element={<Protected><Performance /></Protected>} />
      <Route path="/performance/company" element={<Protected adminOnly><AdminLaporan view="company" /></Protected>} />
      <Route path="/performance/team" element={<Protected adminOnly><AdminLaporan view="team" /></Protected>} />
      <Route path="/performance/:userId" element={<Protected><EmployeeDetail /></Protected>} />
      <Route path="/profile" element={<Protected><Profile /></Protected>} />
      <Route path="/approvals" element={<Protected><Approvals /></Protected>} />
      <Route path="/audit" element={<Protected adminOnly><AuditTrail /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster theme="dark" position="top-right" richColors />
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
